import React from "react";
import { createPortal } from "react-dom";

import {
  ChartData,
  OrgTimeSeriesMetricsData,
} from "../../../../models/ChartCollectionData";
import { DownloadCsvButton } from "../../../AnalysisCollectionsComponents/CollectionChartArea/Download";

import "./styles.scss";

export interface IFacilityDetailsAnalysisControlsProps {
  chartData: ChartData | undefined;
  chartDetails: OrgTimeSeriesMetricsData[];
  prevYearChartDetails: OrgTimeSeriesMetricsData[];
  compareToPrev: boolean;
  timspanPickerPortalKey: string;
}

export const FacilityDetailsAnalysisControls: React.FunctionComponent<
  IFacilityDetailsAnalysisControlsProps
> = (props) => {
  const {
    chartData,
    chartDetails,
    prevYearChartDetails,
    timspanPickerPortalKey,
    compareToPrev,
  } = props;

  if (!chartData) {
    return null;
  }

  // Hack to get around compare_to_prev not being set properly from the API
  // when in individual facility mode.
  const _chartData: ChartData = {
    ...chartData,
    compare_to_prev: compareToPrev,
  };

  // Portal is used to render these download buttons alongside the TimespanPicker component.
  // This is purely for presentation purposes and can be changed if needed to suit design.
  const portalElement = document.getElementById(
    `facility-details-analysis-controls`
  );

  if (!portalElement) {
    return null;
  }

  return (
    <>
      {chartData &&
        createPortal(
          <div className="facility-details-analysis-controls-download">
            <DownloadCsvButton
              chartData={_chartData}
              chartDetailsDataForLines={chartDetails}
              prevYearChartDetailsDataForLines={prevYearChartDetails}
              forWindows={false}
            />
            <DownloadCsvButton
              chartData={_chartData}
              chartDetailsDataForLines={chartDetails}
              prevYearChartDetailsDataForLines={prevYearChartDetails}
              forWindows={true}
            />
            <div id={`timespan-picker-portal-${timspanPickerPortalKey}`}></div>
          </div>,
          portalElement
        )}
    </>
  );
};
